import { NodeObjectRepository } from '@/models/assembly';
import { ConfiguratorService } from '@/services/sketchfab';


export const Reflex  = {
  reflex: {
    steps: [
      {

        order: 1,
        desc: '1',
        apply: async (repository: NodeObjectRepository,configuratorService:ConfiguratorService): Promise<any> => {



          await configuratorService.playPauseAnimation('a1');
          const tekerlekler = repository.get('tekerlek');
          tekerlekler.hide();

          repository.track(tekerlekler);
        },
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/models/assembly/defs/reflex.ts